import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import Seo from '@salesforce/retail-react-app/app/components/seo'
import useFetchLibraryFolders from '../../../../hooks/useFetchLibrary'
import LoadingSpinner from '../../../../components/loading-spinner'
import {contentStyle} from './index.style'
import Breadcrumbs from '../../../../components/breadcrumbs'
import PageNotFound from '../../../../pages/page-not-found'

function TeamCavendersApplication() {
    const {
        data: {page_title, page_description, page_keywords, c_body = ''},
        loading,
        error
    } = useFetchLibraryFolders('content/team-cavenders-application')

    const breadcrumbData = {
        parentFolder: {
            folderId: 'customer-service',
            folderName: 'Customer Service',
            url: '/customer-service'
        },
        contentFolder: {
            folderId: 'team-cavenders-application',
            folderName: "Cavender's Rodeo Team Application",
            url: '/content/team-cavenders-application.html'
        }
    }

    if (loading && !error) {
        return <LoadingSpinner />
    }
    if (error || !c_body) {
        // Display PageNotFound if there's an error or no content body
        return <PageNotFound />
    }

    return (
        <>
            <Breadcrumbs breadcrumbData={breadcrumbData} />
            <Seo title={page_title} description={page_description} keywords={page_keywords} />
            <Box sx={contentStyle} dangerouslySetInnerHTML={{__html: c_body}} />
        </>
    )
}

export default TeamCavendersApplication
